<template>
	<v-btn
      class="clap-way-btn"
		color="#E77C2C"
		href="/clapway/auth"
		rounded
		:width="btnWidth"
		height="50"
	>
		<div class="text-h6 text-sm-h5 white--text font-weight-medium">
			<v-icon v-if="!isRtl" style="vertical-align: text-top" large>mdi-chevron-right</v-icon>
			{{$t("pages.login.create_game")}}
			<v-icon v-if="isRtl" style="vertical-align: text-top" large>mdi-chevron-left</v-icon>
		</div>
	</v-btn>
</template>

<script>
import { isRtl } from "src/locales";
export default {
	name: "WayClapBtn",
  data() {
    return {
      isRtl
    };
  },
	computed:{
		breakpoint(){
			return this.$vuetify.breakpoint.name;
		},
		btnWidth(){
			switch (this.breakpoint){
			case "xs":
				return 200;
			case "sm":
				return 300;
			case "md":
				return 350;
			default:
				return 400;
			}
		},
	}
};
</script>

<style scoped>
.clap-way-btn{
  position: relative;
  z-index: 300;
}


.v-application .text-h6,.v-application .text-sm-h5{
  font-family: Assistant, sans-serif !important;
  font-style: normal;
}
</style>
